import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "input-text" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_MobileInput = _resolveComponent("MobileInput")
  const _component_ContentEditable = _resolveComponent("ContentEditable")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.$responsive.mobile)
      ? (_openBlock(), _createBlock(_component_MobileInput, {
          key: 0,
          ref: "input",
          modelValue: _ctx.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.value) = $event)),
          "allow-resize": $props.allowResize,
          "editor-disabled": $props.editorDisabled,
          class: "input",
          placeholder: $props.placeholder,
          onFocusin: _cache[1] || (_cache[1] = $event => (_ctx.$emit('focusin', $event))),
          onFocusout: _cache[2] || (_cache[2] = $event => (_ctx.$emit('focusout', $event))),
          onPush: _cache[3] || (_cache[3] = $event => (_ctx.$emit('push', $event))),
          onRows: _cache[4] || (_cache[4] = $event => (_ctx.$emit('rows', $event)))
        }, null, 8 /* PROPS */, ["modelValue", "allow-resize", "editor-disabled", "placeholder"]))
      : (_openBlock(), _createBlock(_component_ContentEditable, {
          key: 1,
          ref: "input",
          modelValue: _ctx.value,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.value) = $event)),
          "allow-resize": $props.allowResize,
          "editor-disabled": $props.editorDisabled,
          class: "input",
          "max-rows": 3,
          "line-height": 32,
          "chip-height": 29,
          spellcheck: false,
          placeholder: $props.placeholder,
          maxlength: 2048,
          options: $options.options,
          onFocusin: _cache[6] || (_cache[6] = $event => (_ctx.$emit('focusin', $event))),
          onFocusout: _cache[7] || (_cache[7] = $event => (_ctx.$emit('focusout', $event))),
          onKeydown: _withKeys(_withModifiers($options.onKeyEnter, ["stop"]), ["enter"]),
          onRows: _cache[8] || (_cache[8] = $event => (_ctx.$emit('rows', $event)))
        }, null, 8 /* PROPS */, ["modelValue", "allow-resize", "editor-disabled", "placeholder", "options", "onKeydown"]))
  ]))
}